module.exports = __webpack_public_path__ + "static/media/church.f6d56315.jpg";